module.exports = __webpack_public_path__ + "static/media/Drawer-Dark.dc40fe21.png";